import { gameConstants } from '../constant';
export const gameAction = {
    loadGame,
    getGameUrl,
    updateMerchantProvider,
    updateMerchantProviderCategory,
};

function loadGame(gameObj) {
    return (dispatch) => {
        dispatch({ type: gameConstants.LOAD_GAME_PAGE, payload: gameObj });
    };
}

function getGameUrl(url) {
    return (dispatch) => {
        dispatch({ type: gameConstants.LAUNCH_GAME, payload: url });
    };
}

function updateMerchantProvider(merchantProvider) {
    return (dispatch) => {
        dispatch({ type: gameConstants.UPDATE_MERCHANT_PROVIDER, payload: { merchantProvider } });
    };
}

function updateMerchantProviderCategory(merchantProviderCategory) {
    return (dispatch) => {
        dispatch({ type: gameConstants.UPDATE_MERCHANT_PROVIDER_CATEGORY, payload: { merchantProviderCategory } });
    };
}
